const initConfiguratorSlider = () => {
    const configuratorWidgetsArray = document.querySelectorAll(".configurator-widget");
    if (configuratorWidgetsArray && configuratorWidgetsArray.length > 0) {
        configuratorWidgetsArray.forEach((configuratorWidget) => {
            const dataCarousel = configuratorWidget.querySelector("[data-carousel]");
            if (dataCarousel) {
                const dataSlides = dataCarousel.querySelectorAll("[data-slide]");
                if (dataSlides && dataSlides.length > 2) {
                    initCarousel("[data-carousel]", cellAlign.left, true, false, false, null, null);
                }
                else {
                    dataCarousel.setAttribute("data-carousel", "not-active");
                    configuratorWidget.classList.add("not-slider");
                }
            }
            let isDocumentScrolled = false;
            window.addEventListener("scroll", () => {
                const sectionRectTop = configuratorWidget.getBoundingClientRect().top;
                if (window.innerWidth <= 767) {
                    if (sectionRectTop > 300 && sectionRectTop < 400) {
                        if (!isDocumentScrolled) {
                            isDocumentScrolled = true;
                            console.log("dentro al viewport");
                            initConfiguratorFetch();
                        }
                    }
                }
                else {
                    if (sectionRectTop > 100 && sectionRectTop < 200) {
                        if (!isDocumentScrolled) {
                            isDocumentScrolled = true;
                            console.log("dentro al viewport");
                            initConfiguratorFetch();
                        }
                    }
                }
            });
        });
    }
};
const initConfiguratorFetch = () => {
    const configuratorWidgetsArray = document.querySelectorAll(".configurator-widget");
    if (configuratorWidgetsArray && configuratorWidgetsArray.length > 0) {
        configuratorWidgetsArray.forEach((configuratorWidget) => {
            const stepContainerList = configuratorWidget.querySelectorAll(".step-container");
            let i = 0;
            const dataOption = [];
            stepContainerList.forEach((stepContainer) => {
                setTimeout(() => {
                    if (parseInt(stepContainer.getAttribute("data-number-step-container")) >= 2) {
                        stepTitle.classList.remove("active");
                        accordionContainer.classList.remove("active");
                    }
                }, 500);
                i += 1;
                stepContainer.setAttribute("data-number-step-container", `${i}`);
                const stepTitle = stepContainer.querySelector(".step-title");
                const accordionContainer = stepContainer.querySelector(".accordion-container");
                clickBehaviourAccordion(stepTitle, accordionContainer);
                const stepFeatureList = accordionContainer.querySelectorAll(".step-feature");
                stepFeatureList.forEach((stepFeature) => {
                    stepFeature.addEventListener("click", () => {
                        if (stepFeature.hasAttribute("data-check")) {
                            stepFeature.removeAttribute("data-check");
                            const index = dataOption.indexOf(`options=${stepFeature.getAttribute("data-option")}`);
                            if (index > -1) {
                                dataOption.splice(index, 1);
                            }
                        }
                        else {
                            for (let i = 0; i < stepFeatureList.length; i++) {
                                if (stepFeatureList[i].hasAttribute("data-check")) {
                                    stepFeatureList[i].removeAttribute("data-check");
                                    const index = dataOption.indexOf(`options=${stepFeatureList[i].getAttribute("data-option")}`);
                                    if (index > -1) {
                                        dataOption.splice(index, 1);
                                    }
                                }
                            }
                            stepFeature.setAttribute("data-check", "active");
                            dataOption.push(`options=${stepFeature.getAttribute("data-option")}`);
                        }
                        for (let j = 0; j < stepContainerList.length; j++) {
                            if ((parseInt(stepContainer.getAttribute("data-number-step-container")) + 1) == parseInt(stepContainerList[j].getAttribute("data-number-step-container"))) {
                                const nextStepTitle = stepContainerList[j].querySelector(".step-title");
                                const nextAccordionContainer = stepContainerList[j].querySelector(".accordion-container");
                                if (!nextAccordionContainer.classList.contains("active")) {
                                    nextStepTitle.classList.add("active");
                                    nextAccordionContainer.classList.add("active");
                                    nextStepTitle.scrollIntoView();
                                }
                            }
                        }
                        configuratorFetch(configuratorWidget, dataOption.join("&"));
                    });
                });
            });
        });
    }
};
const configuratorFetch = (configuratorWidget, dataOption) => {
    const resultConfigurationContainer = configuratorWidget.querySelector("[data-result-configurator]");
    const dataResultConfigurator = resultConfigurationContainer.querySelector("[data-configurator-to-append]");
    const dataResultCustomButtonsConfigurator = resultConfigurationContainer.querySelector("[data-custom-buttons-configurator-to-append]");
    const currentLanguage = document.querySelector("html").getAttribute("lang");
    fetch(`/${currentLanguage}/api/configurator/GetResults?${dataOption}`)
        .then(data => {
        //convert the response into plain text
        data.text()
            //resolve the promise
            .then((result) => {
            // Initialize the DOM parser
            const parser = new DOMParser();
            // Parse the text and convert it into HTML
            const parsedHTML = parser.parseFromString(result, "text/html");
            const dataConfiguratorToAppend = parsedHTML.querySelector("[data-configurator-to-append]");
            const dataCustomButtonsConfiguratorToAppend = parsedHTML.querySelector("[data-custom-buttons-configurator-to-append]");
            //get only the cards
            if (dataResultConfigurator) {
                resultConfigurationContainer.removeChild(dataResultConfigurator);
                resultConfigurationContainer.removeChild(dataResultCustomButtonsConfigurator);
                resultConfigurationContainer.append(dataConfiguratorToAppend);
                resultConfigurationContainer.append(dataCustomButtonsConfiguratorToAppend);
            }
            else {
                resultConfigurationContainer.append(dataConfiguratorToAppend);
                resultConfigurationContainer.append(dataCustomButtonsConfiguratorToAppend);
            }
            configuratorRestultsSlider();
        });
    });
};
const clickBehaviourAccordion = (clickElement, description) => {
    clickElement.addEventListener("click", () => {
        if (description.classList.contains("active")) {
            clickElement.classList.remove("active");
            description.classList.remove("active");
        }
        else {
            clickElement.classList.add("active");
            description.classList.add("active");
        }
    });
};
